import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { inputCls, Field, Panel, btnPrimary, errMsg } from "./ui";

export default function SupplierAccessTab() {
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [sid, setSid] = useState("");
  const [all, setAll] = useState(true);
  const [ids, setIds] = useState([]);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/suppliers").then((r) => setSuppliers(r.data));
  useEffect(() => { load(); api.get("/admin/products").then((r) => setProducts(r.data)); }, []);

  const pick = (id) => {
    setSid(id);
    const s = suppliers.find((x) => x.id === id);
    const allowed = s?.allowed_product_ids;
    setAll(allowed == null);
    setIds(allowed || []);
  };
  const toggle = (id) => setIds((cur) => (cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id]));

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/suppliers/${sid}/products`, { all_products: all, product_ids: all ? [] : ids });
      toast.success("Akses produk supplier disimpan");
      load();
    } catch (err) { toast.error(errMsg(err)); } finally { setSaving(false); }
  };

  const summary = (s) => (s.allowed_product_ids == null ? "Semua produk" : `${s.allowed_product_ids.length} produk`);

  return (
    <Panel title="Produk per Supplier" testId="supplier-access-panel">
      <p className="text-sm text-[#A8A8AD] mb-5">Pilih produk yang boleh diajukan oleh tiap supplier. Supplier hanya melihat dan bisa mengajukan produk yang diizinkan.</p>
      <Field label="Supplier" className="max-w-2xl mb-5">
        <select data-testid="access-supplier-select" className={inputCls} value={sid} onChange={(e) => pick(e.target.value)}>
          <option value="">Pilih supplier</option>
          {suppliers.map((s) => <option key={s.id} value={s.id}>{s.name} — {s.email} ({summary(s)})</option>)}
        </select>
      </Field>
      {sid && (
        <>
          <label className="flex items-center gap-2 text-sm text-[#F5F3ED] mb-4">
            <input data-testid="access-all-checkbox" type="checkbox" className="accent-[#D4AF37]" checked={all} onChange={(e) => setAll(e.target.checked)} />
            Izinkan semua produk (termasuk produk baru)
          </label>
          {!all && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 mb-5">
              {products.map((p) => (
                <label key={p.id} data-testid={`access-product-${p.id}`} className={`flex items-center gap-2 text-sm border rounded-sm px-3 py-2 cursor-pointer transition-colors ${ids.includes(p.id) ? "border-[#D4AF37] text-[#F5F3ED]" : "border-[#35353B] text-[#A8A8AD]"}`}>
                  <input type="checkbox" className="accent-[#D4AF37]" checked={ids.includes(p.id)} onChange={() => toggle(p.id)} />
                  {p.name}
                </label>
              ))}
            </div>
          )}
          <button data-testid="access-save-btn" onClick={save} disabled={saving} className={btnPrimary}>{saving ? "Menyimpan..." : "Simpan Akses"}</button>
        </>
      )}
    </Panel>
  );
}
